import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSendFrom = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 26,
	height: 26,
	viewBox: "0 0 26 26",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		opacity: .5,
		clipPath: "url(#clip0_28_4791)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M2.05078 19.9001C2.05078 18.6182 3.08992 17.5791 4.37176 17.5791H15.203C16.4848 17.5791 17.524 18.6182 17.524 19.9001V23.7684H15.9767V19.1264H3.5981L3.5981 23.7684H2.05078L2.05078 19.9001Z",
				fill: "#360802"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M9.78649 16.032C12.3502 16.032 14.4285 13.9537 14.4285 11.39C14.4285 8.82632 12.3502 6.74805 9.78649 6.74805C7.22281 6.74805 5.14453 8.82632 5.14453 11.39C5.14453 13.9537 7.22281 16.032 9.78649 16.032ZM9.78637 14.4847C11.4955 14.4847 12.881 13.0991 12.881 11.39C12.881 9.6809 11.4955 8.29538 9.78637 8.29538C8.07724 8.29538 6.69173 9.6809 6.69173 11.39C6.69173 13.0991 8.07724 14.4847 9.78637 14.4847Z",
				fill: "#360802"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M15.2031 5.45854L22.9397 5.45854L22.9397 7.00586L15.2031 7.00586L15.2031 5.45854Z",
				fill: "#360802"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M18.4941 9.8424L22.1046 6.23199L18.4941 2.62157L19.5883 1.52745L23.1987 5.13787C23.8029 5.74213 23.8029 6.72184 23.1987 7.32611L19.5883 10.9365L18.4941 9.8424Z",
				fill: "#360802"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_28_4791",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24.7571,
			height: 24.7571,
			fill: "white",
			transform: "translate(0.503906 0.558594)"
		})
	}) })]
});
export default SvgSendFrom;
